import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import type { TimelineItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import type { TimelineDateLines } from "web_myplann/NotificationCenter/Types/TimelineDateLines";
import type { TimelineDateStyle } from "web_myplann/NotificationCenter/Types/TimelineDateStyle";
import { mapTimelineEntryDateLines } from "web_myplann/NotificationCenter/Utils/mapTimelineEntryDateLines";

export const useTimelineEntryDateLines = (
	item: TimelineItemResponseDTO,
	dateStyle: TimelineDateStyle,
): TimelineDateLines => {
	const { t } = useResource();
	const hasGoalsRight = useGoalsRightOptional();

	return mapTimelineEntryDateLines(item, dateStyle, t, hasGoalsRight);
};
